import {Marvin, MarvinWindow} from 'chemistry/marvinjs-wrappers/MarvinJSConstants';

export function getMarvinFromIFrameNode(node: HTMLIFrameElement): Marvin | null {
  const marvinWindow = node.contentWindow as MarvinWindow;
  if (!marvinWindow) {
    return null;
  }
  return marvinWindow.marvin;
}
